/**
 * i18n setup (04-architecture § 10). German only (D-008), one namespace, one
 * catalogue for all four apps — apps have no string files of their own.
 *
 * No hard-coded copy anywhere: `eslint-plugin-i18next` enforces it in markup.
 */

import i18next, { type i18n as I18n } from 'i18next';
import de from './de.json';
import { initI18nWith, type Platform } from './init.js';
import type { ApiProblem } from '../api/problem.js';

export type { Platform } from './init.js';

/** The apps' entry: the whole catalogue (every app shares one, D-008). */
export function initI18n(platform: Platform, instance: I18n = i18next): I18n {
  return initI18nWith(platform, de, instance);
}

/**
 * § 10.3 — maps a problem to its key. A screen may ask for a more specific key
 * by passing a context; the context is chosen by the calling screen, never
 * parsed out of `detail`.
 */
export function errorKeyFor(problem: Pick<ApiProblem, 'code'>, context?: string): string {
  return context ? `errors.${problem.code}_${context}` : `errors.${problem.code}`;
}

export { de as messages };
export type MessageKey = string;
